<app-auth-page-layout>
  <div class="flex flex-col flex-1">
    <div class="p-10">
      <a routerLink="/"
        class="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
        <!-- Text logo -->
        <div class="flex items-center gap-3">
          <!-- Shield Icon -->
          <img class="h-10 w-10" src="/images/logo/shield.svg" alt="AbuseXense Shield Logo" />

          <!-- Logo Text -->
          <div class="flex flex-col leading-tight">
            <div class="flex items-baseline">
              <span class="font-extrabold text-gray-900 dark:text-white text-lg">
                Abuse
              </span>
              <span
                class="font-extrabold text-lg bg-gradient-to-r from-[#83B1FF] to-[#5C77FF] bg-clip-text text-transparent">
                Xense
              </span>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
      <div>


        <div class="mb-5 sm:mb-8 text-center">
          @if (resetSuccess) {
          <div class="mb-5">
            <i class="bi bi-check-circle-fill text-green-500 text-7xl"></i>
          </div>
          }
          <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
            {{ resetSuccess ? 'Password Reset!' : 'Reset Password' }}
          </h1>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            {{ resetSuccess ?
            'You\'ve successfully reset your password, click the button below to login.' :
            'Your password must be different from your previously used password.' }}
          </p>
        </div>

        @if (resetSuccess) {
        <app-button className="w-full" size="sm" (btnClick)="onResetPasswordBack()" [disabled]="isSubmitting">
          Login
        </app-button>
        } @else {
        <!-- Form -->
        <form (keyup.enter)="onResetPassword()" (ngSubmit)="onResetPassword()" class="space-y-6">
          <div>
            <app-label>New Password <span class="text-error-500">*</span></app-label>
            <app-input-field type="password" placeholder="Enter your new password" [value]="newPassword"
              (valueChange)="newPassword = $event.toString()" name="newPassword" class="form-input" required
              [disabled]="isSubmitting" />
          </div>

          <div>
            <app-label>Confirm New Password <span class="text-error-500">*</span></app-label>
            <app-input-field type="password" placeholder="Confirm your new password" [value]="confirmPassword"
              (valueChange)="confirmPassword = $event.toString()" name="confirmPassword" class="form-input" required
              [disabled]="isSubmitting" />
          </div>

          <app-button className="w-full" size="sm" (btnClick)="onResetPassword()" [disabled]="!canSubmit">
            @if (isSubmitting) {
            <span class="flex items-center gap-2">
              <span class="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
              Resetting password...
            </span>
            } @else {
            Reset Password
            }
          </app-button>
        </form>
        }

        <div class="mt-4 flex justify-center">
          <button type="button" (click)="onResetPasswordBack()"
            class="inline-flex items-center justify-center gap-2 text-sm leading-none text-brand-500 hover:text-brand-600 dark:text-brand-400"
            [disabled]="isSubmitting">
            <i class="bi bi-arrow-left self-center text-base"></i>
            <span class="self-center leading-none">Back to Login</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</app-auth-page-layout>